import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { setDataViewLoaded, setDataViewLoading } from "@insite/client-framework/Store/Data/DataState";
import { reducers } from "@insite/client-framework/Store/Reducers";
import { RealTimeInventoryModel, RealTimePricingModel } from "@insite/client-framework/Types/ApiModels";
import { GetSubscriptionProductApiParameter } from "@TKCCP/Services/tkccpSubscriptionProductsService";
import {
    getSubscribedProducts,
    products,
    subscribedProductList,
    subscribedProductListCollection,
    subscriptionActiveListModel,
    SubscriptionProductServiceCollectionModel,
} from "@TKCCP/Types/ApiModels";
import { Draft } from "immer";

import cloneDeep from "lodash/cloneDeep";

import { SubscriptionProductStateData } from "@TKCCP/Store/CustomHandlerCreator/SubscriptionProductStateData";

const initialState: SubscriptionProductStateData = {
    products: [],
    productInfoBySubscription: {},
    realtimePricingProduct: [],
    realTimeInventoryProduct: [],
    setSubscriptionProductIsSelected: [],
    setSubscribedProduct: [],
    editPageSubscriptionProductList: [],
    subscriptionActiveFlag: false,
};

const reducer = {
    // "Data/SubsriptionProductService/BeginLoadSubsriptionProduct": (
    //     draft : Draft<SubscriptionProductSerivceState>,
    //     action: {parameter: GetSubscriptionProductApiParameter}
    // ) => {
    //     // setDataViewLoading(draft, action.parameter);
    //     return Draft.isLoading = false;
    // },

    "Data/SubsriptionProductService/InitalValuesProduct": (draft: Draft<SubscriptionProductStateData>) => {
        draft.products = [];
        draft.productInfoBySubscription = {};
        draft.realtimePricingProduct = [];
        draft.realTimeInventoryProduct = [];
        draft.setSubscriptionProductIsSelected = [];
    },
    "Data/SubsriptionProductService/CompleteLoadSubsriptionProduct": (
        draft: Draft<SubscriptionProductStateData>,
        action: {
            parameter: GetSubscriptionProductApiParameter;
            collection: SubscriptionProductServiceCollectionModel;
        },
    ) => {
        draft.productInfoBySubscription = {};
        const listProducts = action.collection.products;
        for (let i = 0; i < listProducts.length; i++) {
            draft.products[i] = { ...listProducts[i], IsActive: false };
        }
    },
    "Data/SubsriptionProductService/realtimeProduct": (
        draft: Draft<SubscriptionProductStateData>,
        action: {
            products: any;
            realTimePricing: RealTimePricingModel;
        },
    ) => {
        draft.realtimePricingProduct = action.realTimePricing.realTimePricingResults;
        const productsData = action.products;
        const listOfProductId = productsData.map((val: products, ind: number) => {
            return val.productId;
        });

        if (action.realTimePricing?.realTimePricingResults) {
            for (const productId of action.realTimePricing.realTimePricingResults) {
                const productIds = productId["productId"];
                const indexOfProduct = listOfProductId.indexOf(productIds);
                draft.productInfoBySubscription[productIds] = {
                    productId: productIds,
                    qtyOrdered: productsData[indexOfProduct].productMinimumOrderQty,
                    unitOfMeasure: productsData[indexOfProduct].productUnitOfMeasure,
                    productDetailPath: "",
                    pricing: productId,
                };
            }
        }
    },
    "Data/SubsriptionProductService/CompleteLoadProductInfos": (
        draft: Draft<SubscriptionProductStateData>,
        action: { productInfoBySubscription: SafeDictionary<ProductInfo> },
    ) => {
        // console.log(action,"action")
        // eslint-disable-next-line no-return-assign
        // draft.productInfoBySubscription = action.productInfoBySubscription;

        // console.log(draft.productInfoBySubscription)

        // const newState = cloneDeep(action.productInfoBySubscription);

        // console.log(action.productInfoBySubscription,"prashant",newState)
        // draft.productInfoBySubscription = action.productInfoBySubscription;

        // draft.productInfoBySubscription = action.productInfoBySubscription
        // if(action.productInfoBySubscription.length) {
        //     const
        // }

        for (const productId in action.productInfoBySubscription) {
            const productInfo = action.productInfoBySubscription[productId]!;
            draft.productInfoBySubscription[productId] = productInfo;

        }
        // draft.productInfoBySubscription = {}
    },

    "Data/SubsriptionProductService/CompleteLoadRealTimeInventory": (
        draft: Draft<SubscriptionProductStateData>,
        action: { realTimeInventory: RealTimeInventoryModel },
    ) => {
        // eslint-disable-next-line array-callback-return
        const listOfProductId = draft.products.map((val: products) => {
            return val.productId;
        });

        if (action.realTimeInventory?.realTimeInventoryResults) {
            for (const inventoryProduct of action.realTimeInventory.realTimeInventoryResults) {
                const productIds = inventoryProduct["productId"];
                const indexOfProduct = listOfProductId.indexOf(productIds);
                draft.productInfoBySubscription[productIds] = {
                    ...draft.productInfoBySubscription[productIds],
                    inventory: inventoryProduct,
                };
            }
        }
    },
    "Data/SubsriptionProductService/SetSubscriptionProductIsSelected": (
        draft: Draft<SubscriptionProductStateData>,
        action: { selectedPorduct: any },
    ) => {

        if (action.selectedPorduct.editProductPageFlag) {
            draft.editPageSubscriptionProductList = [...draft.editPageSubscriptionProductList, action.selectedPorduct];
        }

        if (action.selectedPorduct.IsActive) {
            draft.setSubscriptionProductIsSelected = [
                ...draft.setSubscriptionProductIsSelected,
                action.selectedPorduct,
            ];
        } else {
            draft.setSubscriptionProductIsSelected = draft.setSubscriptionProductIsSelected.filter((val: any) => {
                return val.ProductId !== action.selectedPorduct.ProductId;
            });
        }

        const updatedQuantityProduct = draft.setSubscriptionProductIsSelected.filter((value: any) => {
            return value.updateExistingProduct;
        });

        if (updatedQuantityProduct.length) {
            draft.setSubscriptionProductIsSelected = draft.setSubscriptionProductIsSelected
                .map((value: any) => {
                    if (value.ProductId === updatedQuantityProduct[0].ProductId && !value.updateExistingProduct) {
                        return {
                            IsActive: true,
                            ProductERPNumber: value.ProductERPNumber,
                            ProductId: value.ProductId,
                            QtyOrdered: updatedQuantityProduct[0].QtyOrdered,
                            UnitOfMeasure: value.UnitOfMeasure,
                        };
                    }
                    return value;
                })
                .slice(0, draft.setSubscriptionProductIsSelected.length - 1);
        }

    },

    "Data/SubsriptionProductService/getSubscribedProducts": (
        draft: Draft<SubscriptionProductStateData>,
        action: {
            parameter: GetSubscriptionProductApiParameter;
            collection: subscribedProductListCollection;
        },
    ) => {
        const listofSubscribedProducts = action.collection.subscriptionList;
        if (listofSubscribedProducts) {
            for (let i = 0; i < listofSubscribedProducts.length; i++) {
                draft.setSubscribedProduct[i] = { ...listofSubscribedProducts[i] };
            }
        }
    },

    "Data/SubsriptionProductService/getSubscriptionActive": (
        draft: Draft<SubscriptionProductStateData>,
        action: {
            parameter: GetSubscriptionProductApiParameter;
            collection: subscriptionActiveListModel;
        },
    ) =>{
        draft.subscriptionActiveFlag = action.collection.isAnyActiveSubscription;
    }
};

export default createTypedReducerWithImmer(initialState, reducer);

// const subscriptionprodcutreducer = createTypedReducerWithImmer(initialState, reducer);
// (reducers as any).subscriptionProductIdentity = subscriptionprodcutreducer;
